<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Lucro no Período {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="bg-warning btn-round text-white" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
              <input type="date" class="form-control mx-2 d-inline-block mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
              <input type="date" class="form-control mx-2 d-inline-block mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
              <n-button type="primary" class="btn btn-round btn-wd d-inline-block btn-info mx-auto-mobile mb-2-mobile filter-btn" v-on:click.native="filtrar">Filtrar</n-button>
              <!-- <input class="pull-right form-control dont-float-mobile" placeholder="Pesquisar..." v-model="filter" style="max-width: 250px"> -->
            </div>
          </div>
          <div class="row" style="margin-top: 25px;">

               <div class="col-md-1 col-sm-4 col-xs-6">
                </div>


               <div class="col-md-2 col-sm-4 col-xs-6">
                  <div class="material-card" style="">
                    <div class="card-content">
                      <a><i class="fa fa-fw fa-usd money-color"></i></a><br>
                      <h5>
                       <a style="font-size:15px;">R$ </a><strong><animated-number :value="valor_total"></animated-number></strong>
                      </h5>
                    </div>
                    <div class="mc-footer">
                      <strong>LUCRO</strong>
                    </div>
                  </div>
                </div>

                 <div class="col-md-2 col-sm-4 col-xs-6">
                  <div class="material-card" style="">
                    <div class="card-content">
                      <a><i class="fa fa-arrow-up blue-color"></i></a><br>
                      <h5>
                       <a style="font-size:15px;">R$ </a><strong><animated-number :value="sum.sum_vendas"></animated-number></strong>
                      </h5>
                    </div>
                    <div class="blue-footer">
                     <a><strong>VENDAS</strong></a>
                    </div>
                  </div>
                </div>

                 <div class="col-md-2 col-sm-4 col-xs-6">
                  <div class="material-card" style="">
                    <div class="card-content">
                      <a><i class="fa fa-shopping-bag yellow-color"></i></a><br>
                      <h5>
                       <a style="font-size:15px;">R$ </a><strong><animated-number :value="sum.sum_custos"></animated-number></strong>
                      </h5>
                    </div>
                    <div class="orange-footer"  style="position: relative;">
                        <a><strong>CUSTOS</strong></a>
                        <a @click="OnOffCusto()"><i v-if="!custos" class="fa fa-toggle-off" style="font-size:18px;color: #333 ; cursor: pointer; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                        <a @click="OnOffCusto()"><i v-if="custos" class="fa fa-toggle-on" style="font-size:18px;color: #333; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                    </div>
                  </div>
                </div>

                 <div class="col-md-2 col-sm-4 col-xs-6">
                  <div class="material-card" style="">
                    <div class="card-content">
                      <a><i class="fa fa-credit-card yellow-color"></i></a><br>
                      <h5>
                       <a style="font-size:15px;">R$ </a><strong><animated-number :value="sum.sum_taxas"></animated-number></strong>
                      </h5>
                    </div>
                    <div class="mc-footer-yellow" style="position: relative;">
                      <div>

                          <a><strong>TAXAS</strong></a>
                          <a @click="OnOffTaxas()"><i v-if="!taxas" class="fa fa-toggle-off" style="font-size:18px;color: #333 ; cursor: pointer; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                          <a @click="OnOffTaxas()"><i v-if="taxas" class="fa fa-toggle-on" style="font-size:18px;color: #333; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                 <div class="col-md-2 col-sm-4 col-xs-6">
                  <div class="material-card" style="">
                    <div class="card-content">
                      <a><i class="fa fa-arrow-down red-money-color"></i></a><br>
                      <h5>
                       <a style="font-size:15px;">R$ </a><strong><animated-number :value="sum.sum_despesas"></animated-number></strong>
                      </h5>
                    </div>
                    <div class="mc-footer-red" style="position: relative;">
                      <a><strong>DESPESAS</strong></a>
                       <a @click="OnOffDespesas()"><i v-if="!despesas" class="fa fa-toggle-off" style="font-size:18px;color: #333 ; cursor: pointer; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                       <a @click="OnOffDespesas()"><i v-if="despesas" class="fa fa-toggle-on" style="font-size:18px;color: #333; position: absolute; bottom: 5px; right: 5px;" aria-hidden="true"></i></a>
                    </div>
                  </div>
                </div>
          </div>
          <div class="row" style="margin: 15px;">
          
        </div>

               
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Card,
    AnimatedNumber
  } from 'src/components'
  import { Chart } from 'chart.js';
  import moment from 'moment'
  import jQuery from 'jquery'
  import GlobalFunctions from '../../../globalFunctions.js'
  import VendaService from '@/services/VendaService.js'

  export default {
    components: {
      Card,
      AnimatedNumber,
      moment,
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        prods: [],
        filter: '',
        custos: true,
        taxas: true,
        despesas: true,
        sum: [],
      }
    },
    computed:{
      valor_total() {
        if(this.sum) {
          let sum_lucro = this.sum.sum_lucro

          if(!this.custos) {
            sum_lucro += this.sum.sum_custos
          }
          
          if(!this.taxas) {
            sum_lucro += this.sum.sum_taxas
          }

          if(!this.despesas) {
            sum_lucro += this.sum.sum_despesas
          }


          return sum_lucro
        }

        return 10
      },

    },
    methods: {
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadLucro()
      },
      OnOffCusto(){
        if(this.custos){
          this.custos = false
        }else{
          this.custos = true
        }
      },
      OnOffTaxas(){
        if(this.taxas){
          this.taxas = false
        }else{
          this.taxas = true
        }
      },
      OnOffDespesas(){
        if(this.despesas){
          this.despesas = false
        }else{
          this.despesas = true
        }
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },
       search() {
        this.loadLucro()
      },
      loadLucro() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`;

        VendaService.loadLucro(params).then(res => {
          this.sum = res.data
        }).catch(err => {
          console.error(err)
        })
      },

    },
    mounted(){
      this.loadLucro()
    }
}
</script>


<style>
.money-color{
  color: #58b458;
  font-size: 25px;
  padding-top: 10px;
}
.red-money-color{
  color: red;
  font-size: 25px;
  padding-top: 10px;
}

.gray-color{
  color: #333;
  font-size: 25px;
  padding-top: 10px;
}

.blue-color{
  color: #2A6FB8;
  font-size: 25px;
  padding-top: 10px;
}
.yellow-color{
  color: #ffc107;
  font-size: 25px;
  padding-top: 10px;
}
.orange-color{
  color: orange;
  font-size: 25px;
  padding-top: 10px;
}
.mc-footer{
  background-color: #58b458;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.blue-footer{
  background-color: #2A6FB8;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.orange-footer{
  background-color: orange;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.mc-footer-yellow{
  background-color: #ffc107;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.mc-footer-red{
  background-color: red;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
</style>